import { Event_ } from '../Event_';
export class MouseEvent_ extends Event_ {
    get clientX() {
        return this.reactEvent.clientX;
    }
    get clientY() {
        return this.reactEvent.clientY;
    }
    get pageXInPixel() {
        return this.reactEvent.pageX;
    }
    get pageYInPixel() {
        return this.reactEvent.pageY;
    }
    get stageXInPixel() {
        return this.pageXInPixel - this.app.stage.inner.aspectMount.measureToWindowIncludingTransform.aspectLeftInPixel;
    }
    get stageYInPixel() {
        return this.pageYInPixel - this.app.stage.inner.aspectMount.measureToWindowIncludingTransform.aspectTopInPixel;
    }
    get aspectXInPixel() {
        if (!this.eventAspect.aspect)
            return 0;
        if (this.eventAspect.aspect.aspectMounts.isAspectMounted) {
            return this.pageXInPixel - this.eventAspect.aspect.aspectMount.measureToWindowIncludingTransform.aspectLeftInPixel;
        }
        return 0;
    }
    get aspectYInPixel() {
        if (!this.eventAspect.aspect)
            return 0;
        if (this.eventAspect.aspect.aspectMounts.isAspectMounted) {
            return this.pageYInPixel - this.eventAspect.aspect.aspectMount.measureToWindowIncludingTransform.aspectTopInPixel;
        }
        return 0;
    }
    get aspectXInUnits() {
        return this.aspectXInPixel / this.app.stage.stageInnerMeasure.stageWidthRatio;
    }
    get aspectYInUnits() {
        return this.pageYInPixel / this.app.stage.stageInnerMeasure.stageHeightRatio;
    }
    get pageXInUnits() {
        return this.pageXInPixel / this.app.stage.stageInnerMeasure.stageWidthRatio;
    }
    get pageYInUnits() {
        return this.pageYInPixel / this.app.stage.stageInnerMeasure.stageHeightRatio;
    }
    get stageXInUnits() {
        return this.stageXInPixel / this.app.stage.stageInnerMeasure.stageWidthRatio;
    }
    get stageYInUnits() {
        return this.stageYInPixel / this.app.stage.stageInnerMeasure.stageHeightRatio;
    }
    get nearestAspect() {
        let el = this.reactEvent.target;
        while (el.parentElement && !el.aspect) {
            el = el.parentElement;
        }
        return el.aspect;
    }
    get nearestActor() {
        return this.nearestAspect && this.nearestAspect.actor;
    }
}
